import React from 'react'
import PropTypes from 'prop-types'
import connect from 'react-redux/es/connect/connect'
import UI from '../../../constants/UI'

const TopBarDefault = (props) => {
    const { resources } = props
    const resourceElements = Object.keys(resources).map((type) => {
        const { icon, name } = UI.RESOURCES[type]
        return (
            <div key={`topBar__resources--item res_${type}`} title={name} className={`resources__bar--item resource_${type}`}>
                <span className="topBar__resources--icon">{icon}</span>
                <span className="topBar__resources--amount">{resources[type]}</span>
            </div>
        )
    })
    return (
        <div className="topBar__default">
            {/* <button type="button" className="topBar__button">Menu</button> */}
            {resourceElements}
        </div>
    )
}

TopBarDefault.propTypes = {
    resources: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    resources: state.resources,
})

export default connect(
    mapStateToProps,
)(TopBarDefault)
